export const autoCompleteType = `
{
  id
  name
}
`;

export const CompanyAutoCompleteType = `
{
  id
  name
  divisions
}
`;

export const profileGroupType = `
{
  id
  role
  profile {
    id
    display_name
    email
  }
}
`;

export const publicProfileType = `
{
  id
  display_name
  email
  company_id
}
`;

export const profileType = `
{
  id
  email
  role
  display_name
  photo_url
  phone
  country
  address
  state
  city
  postcode
  about
  is_public
  is_disabled
  company_id
  company_role
  company {
    name
    type
    private_data {
      plan
      consultancy_id
      product_group
      is_boss
      licenses
    }
  }
}
`;

/*
  profile_groups(where: { group: { type: { _eq: "product" } } }) {
    group {
      id
      name
      type
    }
  }
*/
export const specProjectListType = `
{
  id
  name
  address
  code
  cost
  created_at
  updated_at
  is_archived
  client
  owner
  image_url
  spec_project_companies {
    company {
      id
      name
    }
  }
  spec_project_calendars {
    id
    name
    due
  }
  group {
    profile_groups {
      profile {
        id
        email
        display_name
      }
    }
  }
  spec_project_profiles {
    id
    profile_id
    is_star
  }
}
`;

export const revisionListType = `
{
  created_at
  created_by
  id
  label
  name
  sheet_id
  updated_at
  profile {
      id
      email
      display_name
  }
}
`;

export const revisionDiffType = `
{
    created_at
    created_by
    id
    name
    sheet_id
    updated_at
    sheet_rows
    sheet_seq
    profile {
        id
        email
        display_name
    }
  }
`;

export const specProjectType = `
{
  address
  code
  cost
  created_at
  created_by
  description
  gfa
  green_star
  id
  name
  notes
  procurement_type
  numbering
  schedule_print_header
  schedule_print_footer
  state
  region
  revit
  owner,
  consultancy_id,
  is_archived,
  nda,
  client,
  image_url,
  profile {
    id
    email
    display_name
  }
  spec_project_companies {
    company {
      id
      name
      logo
    }
  }
  spec_project_profiles {
    id
    spec_project_id
    profile_id
    is_star
  }
  spec_project_sectors {
    id
    name
  }
  spec_project_work_types {
    id
    name
  }
  spec_project_calendars {
    id
    spec_project_id
    name
    due
    is_completed
  }
  group {
    id
    name
    profile_groups {
      id
      role
      profile {
        id
        email
        display_name
      }
    }
  }
  sheets(where: { parent_id: { _is_null: true }}) {
    id
    columns
    print_columns
    created_at
    seq
    type
    name
    updated_at
    is_master
    is_locked
    is_archived
    sheet_profiles {
      id
      sheet_id
      profile_id
      is_star
    }
    revisions(order_by: {created_at: desc}) {
      created_at
      created_by
      id
      name
      sheet_id
      updated_at
      profile {
        id
        email
        display_name
      }
    }
  }
}
`;

export const specProjectParamType = `
{
  id
  key
  value
  created_at
  updated_at
  spec_project_id
}
`;

export const productType = `
{
  id
  item
  name
  description
  has_descriptive
  descriptive
  image_url
  datasheet
  section
  code
  cis
  caws
  guidance
  manufacturer_guidance
  warranty
  division
  company {
    id
    name
    logo
  }
  certifications {
    id
    name
    url
    category
    code
  }
  status
  uniclass
  uniclass_system
  omniclass
  regions
  companyByForCompanyId {
    id
    name
  }
  updated_at
  profile {
    id
    email
    display_name
  }
}
`;

export const productSearchType = `
{
  id
  name
}
`;

export const sheetRowType = `
{
  id
  code
  certifications
  contacts
  custom
  datasheet
  description
  image
  item
  level
  location
  manufacturers
  notes
  section
  selected
  sheet_id
  source
  revision_id
  is_deleted
  created_at
  status
  is_request
  created_by,
  tick
}
`;

export const sheetType = `
{
  columns
  print_columns
  print_rows
  print_header_columns
  print_header
  print_footer
  cover
  id
  name
  seq
  spec_project_id
  type
  colors
  is_master
  is_locked
  is_archived
  headers
  children(limit: 1) {
    id
  }
  group {
    id
    name
    profile_groups {
      id
      role
      profile {
        id
        email
        display_name
      }
    }
  }
  sheet_profiles {
    id
    sheet_id
    profile_id
    is_star
    viewed_at
  }
  spec_project{
    id
    name
    schedule_print_header
    schedule_print_footer
    numbering
    address
    region
    state
    country
    code
    client
    spec_project_companies {
      company {
        id
        name
        logo
      }
    }
    spec_project_params(order_by: {key: asc}) {
      id
      key
      value
    }
    company{
      id
      region
    }
  }
  revisions(order_by: {created_at: desc}) {
    created_at
    created_by
    id
    name
    label
    sheet_id
    updated_at
    profile {
      id
      email
      display_name
    }
  }
}
`;

export const publicSheetType = `
{
  columns
  print_columns
  print_rows
  print_header_columns
  print_header
  print_footer
  id
  name
  seq
  spec_project_id
  type
  colors
  is_master
  is_locked
  is_archived
  headers
}
`;

export const specSectionCommentType = `
{
  id
  content
  discussion_id
  edited_at
  deleted_at
  created_by
  created_at

  profile {
    id
    display_name
    photo_url
  }
}
`;

export const specSectionDiscussionType = `
{
  id
  content
  spec_section_id
  suggestion_id
  resolved_at
  created_by
  created_at
}
`;

export const specSectionType = `
{
  id
  name
  content
  excluded
  section
  spec_id
  is_deleted
  created_at
  updated_at
}
`;

export const specScopeType = `
{
  id
  name
  section
  spec_id
  created_at
  created_by
}
`;

export const specShowScopeType = `
{
  id
  spec_id
  spec_scope_id
}
`;

export const specType = `
{
  id
  name
  is_master
  numbering
  headings
  master_id
  selection_sheet_id
  spec_project_id
  print_header
  print_footer
  spec_project {
    id
    name
    schedule_print_header
    schedule_print_footer
    numbering
    region
    code
    spec_project_companies {
      company {
        id
        name
        logo
      }
    }
    spec_project_params {
      id
      key
      value
    }
    group {
      id
      name
      profile_groups {
        id
        role
        profile {
          id
          email
          display_name
        }
      }
    }
    company{
      id
      region
    }
  }
}
`;

export const constructionProjectType = `
{
  address
  appointment_method
  category
  construction_end_date
  construction_start_date
  contract_type
  council
  suburb
  country
  created_at
  da_end_date
  da_id
  da_submission_date
  description
  descriptions
  development_type
  floor_area
  green_building
  id
  ownership_type
  postcode
  project_contacts {
    address
    created_at
    email
    id
    name
    phone
    company
    project_id
    type
    updated_at
    website
    source
  }
  project_resources {
    created_at
    id
    name
    project_id
    type
    updated_at
    url
  }
  profile {
    id
    display_name
    role
    email  
  }
  project_sectors {
    id
    name
  }  
  region
  site_area
  stage
  state
  status
  sub_category
  summary
  tender_end_date
  tender_id
  tender_submission_date
  title
  updated_at
  reviewer_id
  review_status
  cost
  estimated_cost
  source
  related_project_id
}
`;

export const constructionProjectNoFollowType = `
{
  source
  source_id  
}
`;

export const constructionProjectUpdateType = `
{
  address
  appointment_method
  category
  construction_end_date
  construction_start_date
  contract_type
  council
  suburb
  country
  created_at
  da_end_date
  da_id
  da_submission_date
  description
  descriptions
  development_type
  floor_area
  green_building
  id
  ownership_type
  postcode
  contact
  resource
  region
  site_area
  stage
  state
  status
  sub_category
  summary
  tender_end_date
  tender_id
  tender_submission_date
  title
  updated_at
  project_id
  cost
  estimated_cost
  source
  contact
  resource
}
`;

export const projectProfileType = `
{ 
    id
    project_id
    profile_id
    is_star
  }
`;

export const sheetListType = `
{
  id
  name
  type
  is_master
  is_locked
  is_archived
  columns
  children(limit: 1) {
    id
  }
  spec_project {
    id
    name
    spec_project_companies {
      company {
        id
        name
        logo
      }
    }
  }
  sheet_profiles {
    id
    sheet_id
    profile_id
    is_star
    viewed_at
  }
  revisions_aggregate {
    aggregate {
      max {
        created_at
      }
    }
    nodes {
      created_at
      id
      name
      profile {
        id
        display_name
      }
    }
  }
}
`;

export const specListType = `
{
  id
  name
  is_master
  headings
  selection_sheet_id
  spec_project_id
  spec_project {
    id
    name
  }
}
`;

export const specRevisionListType = `
{
  created_at
  created_by
  id
  label
  name
  spec_id
  updated_at
  profile {
      id
      email
      display_name
  }
  spec_revision_sections {
    id
    content
    section_id
    spec_revision_id
  }
}
`;

export const specRevisionSectionType = `
{
  created_at
  id
  content
  section_id
  spec_revision_id
}
`;

export const messageType = `
{
  id
  body
  content_type
  is_resolved
  created_at
  updated_at
  company_id
  profile {
    id
    display_name
    company_id
    company {
      name
    }
  }
}
`;

export const commentWithSheetRowType = `
{
  body
  content_type
  created_at
  created_by
  id
  is_resolved
  sheet_row {
    id
    item
    code
  }
  profile {
    id
    display_name
  }
  resolved_by_profile {
    id
    display_name
  }
}
`;

export const sheetRowAuditType = `
{
  id
  created_at
  old_row
  new_row
  sheet_row_id
  profile {
    id
    display_name
  }
}
`;

export const notificationProfileType = `
{
  id
  notification {
    id
    info
    type
    created_at
  }
}
`;

export const companyType = `
{
  id
  source
  url
  type
  name
  address
  suburb
  region
  state
  postcode
  website
  email
  phone
  other
  is_verified
  domain
  logo
  parent_id
  product_group
  divisions
  private_data {
    plan
    licenses
  }
}
`;

export const usersByRole = `
{
  id
  display_name  
  role
}`;

export const invitationType = `
{
  id
  created_by  
  email
  table
  table_id
  is_approved
}`;

export const specProjectProfileType = `
{
  id
  spec_project_id
  profile_id
  created_at
  updated_at
  is_star
}
`;

export const sheetProfileType = `
{
  id
  sheet_id
  profile_id
  created_at
  updated_at
  is_star
  viewed_at
}
`;

export const specProjectCalendarType = `
{
  id
  spec_project_id
  name
  due
  spec_project {
    id
    name
  }
  is_completed
}
`;

export const taskType = `
{
  id
  name
  due
  is_completed
  profile_id
}
`;

export const clientType = `
{
  id
  company_id
  client_id
}
`;

export const consultancySettingsType = `
{
  id
  consultancy_id
  key
  value
}
`;

export const templateType = `
{
  id
  company_id
  name
  path
}
`;

export const analyticsNominationsTotalType = `
{
  id
  manufacturer_id
  year
  month
  item
  nominations
  competitor_nominations
  unassigned_nominations
  division
}
`;

export const sheetRowProductType = `
{
  id
  sheet_row_id
  manufacturer_name
  product_name
  product_id
  manufacturer_id
  created_at
  item
  sheet_row_updated_at
}
`;

export const analyticsNominationsDetailType = `
{
  sheet_row_product_id
  manufacturer_id
  manufacturer_name
  product_name
  item
  id
  created_at
  updated_at
  name
  address
  notes
  code
  cost
  gfa
  green_star
  procurement_type
  created_by
  state
  country
  numbering
  description
  consultancy_id
  region
  created_by_company
  terms
  architects
  sectors
  work_types
  owner
  program
  sheet_row_code
  division
  sheet_row_created_at
  sheet_row_description_last_updated_at
}
`;

export const analyticsProjectsValueTotalType = `
{
  manufacturer_id
  total_cost
  total_percentage
}
`;

export const uniclassType = `
{
  id
  title
  caws
  csi
  ncs
  omniclass
}
`;

export const standardType = `
{
  id
  code
  label
  url
  region
  created_at
  updated_at
}
`;

export const productCompanyType = `
{
  id
  product_id
  company_id
  is_star
  guidance
}
`;

export const companyContactType = `
{
  id
  company_id
  name
  email
  phone
  state
  role
  other
  main
}
`;

export const printTemplateType = `
{
  id
  title
  print_columns
  print_footer
  print_header
  print_header_columns
  print_rows
  cover
  created_by
  for_company_id
  consultancy_id
  created_at
  profile {
    display_name
  }
}
`;
